/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";


import "../../../../assets/vendor/nucleo/css/nucleo.css";
import "../../../../assets/vendor/font-awesome/css/font-awesome.min.css";
import "../../../../assets/scss/argon-design-system-react.scss?v1.1.0";

import "assets/fonts/Inter-VariableFont.ttf";

// section components
import './Index.css'
import StoreNavbar from "../../../../components/Navbars/StoreNavbar/Index";
import Footer from "../../../../components/Footers/StoreFooter/Footer";
import CheckoutDetails from "./CheckoutDetails.js";
import { ProductContext } from '../Context/productContext.js';



class Checkout extends React.Component {
  static contextType = ProductContext;

  state = {};

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    const { selectedProduct, selectedPlan } = this.context;


    return (
      <div className="main-landing-page">

        <StoreNavbar />

        <main ref="main">

            <CheckoutDetails/>


            <Footer></Footer>
          
        </main>

      </div>
    );
  }
}

export default Checkout;
